import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { initializeLDClient } from "@/lib/launchdarkly";
const CLIENT_SIDE_ID = process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID;
type LaunchDarklyContextType = {
  flags: Record<string, boolean>;
  loading: boolean;
};
const LaunchDarklyContext = createContext<LaunchDarklyContextType>({
  flags: {},
  loading: true
});
export function LaunchDarklyProvider(t0) {
  const $ = _c(10);
  const {
    children,
    company
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [flags, setFlags] = useState(t1);
  const [loading, setLoading] = useState(true);
  let t2;
  let t3;
  if ($[1] !== company) {
    t2 = () => {
      const client = company ? initializeLDClient(CLIENT_SIDE_ID ?? "", {
        email: company.email,
        companyId: Number(company.id).toString()
      }) : initializeLDClient(CLIENT_SIDE_ID ?? "", null);
      if (!client) {
        setLoading(false);
        return;
      }
      const cachedFlags = client.allFlags();
      if (Object.keys(cachedFlags).length > 0) {
        setFlags(cachedFlags);
        setLoading(false);
      }
      const onReady = () => {
        setFlags(client.allFlags());
        setLoading(false);
      };
      const onChange = changes => {
        setFlags(prevFlags => ({
          ...prevFlags,
          ...Object.fromEntries(Object.entries(changes).map(_temp))
        }));
      };
      client.on("ready", onReady);
      client.on("change", onChange);
      return () => {
        if (typeof client.off === "function") {
          client.off("ready", onReady);
          client.off("change", onChange);
        }
      };
    };
    t3 = [company];
    $[1] = company;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== flags || $[5] !== loading) {
    t4 = {
      flags,
      loading
    };
    $[4] = flags;
    $[5] = loading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t4) {
    t5 = <LaunchDarklyContext.Provider value={t4}>{children}</LaunchDarklyContext.Provider>;
    $[7] = children;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(t0) {
  const [key, value] = t0;
  return [key, value.current];
}
export function useLaunchDarkly() {
  const context = useContext(LaunchDarklyContext);
  if (context === undefined) {
    throw new Error("useLaunchDarkly must be used within a LaunchDarklyProvider");
  }
  return context;
}